import { Injectable } from '@angular/core';
import { CanActivate, RouterStateSnapshot, ActivatedRouteSnapshot } from '@angular/router';
import { Router } from '@angular/router';
import { UserService } from '../../service/user.service';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class AuthGuard implements CanActivate {
    constructor(private router: Router, public services: UserService) { }

    private isSubscribedUser : String = "false";

    isSubscribed(){
        return this.isSubscribedUser;
    }

    isAuthenticated(){
        // auth logic
        // if (localStorage.getItem('isLoggedin') === 'true') {
        //     return true;
        // }
        // return false;
        // const userCookies = document.cookie.match(/isSubscribeUser[^;]+/);
        // if (userCookies) {
        //     const value = userCookies[0].split('=');
        //     if (value[1] === 'true') {
        //         return true;
        //     }
        //     return false;
        // }
        // return false;
        this.isSubscribedUser = 'true';
        const userCookies = document.cookie.match(/Id[^;]+/);
        if (userCookies) {
            const value = userCookies[0].split('=');
            this.services.verifySubscribeUser(value[1])
            .subscribe(result=>{
                if (result.order_status === 'SUCCESS') {
                  
                   this.isSubscribedUser = 'SUCCESS';
                   this.canActivate();
                } else {
                    this.isSubscribedUser = 'FAILED'
                    this.canActivate();
                }
            })            
        } else {
            this.router.navigate(['/login'])
        }
    }

    canActivate(){
        const isAuth = this.isSubscribedUser;

        if (this.isSubscribed() === 'SUCCESS') {
            return true;            
        } else if(this.isSubscribed() === 'FAILED'){
            this.router.navigate(['/payments']);
            return false;            
        } else if(this.isSubscribed() == 'false'){
            this.isAuthenticated();
            this.canActivate();        
        } 
        
    }

}



// WEBPACK FOOTER //
// ./src/app/shared/guard/auth.guard.ts